import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/app/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/Cookies/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EshopContextProvider"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/EshopProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/eshop/components/Navbar/index.tsx");
